import { render, staticRenderFns } from "./roleDialog.vue?vue&type=template&id=fe2740e2&scoped=true&"
import script from "./roleDialog.vue?vue&type=script&lang=js&"
export * from "./roleDialog.vue?vue&type=script&lang=js&"
import style0 from "./roleDialog.vue?vue&type=style&index=0&id=fe2740e2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe2740e2",
  null
  
)

export default component.exports